define([
    "./sanitizeModule",
], function (module) {
    "use strict";

    var div = document.createElement("div");

    return module.service("sanitizeService", ["$sanitize", function ($sanitize) {
        return function (text) {
            if (!text) {
                return text;
            }
            // retorna o texto como ele será exibido em tela,
            // trocando caracteres codificados para sua versao utf8
            div.innerHTML = $sanitize(text);
            return div.textContent;
        };
    }]);
});